// extracted by mini-css-extract-plugin
export default {"container":"bRIbgE3f9TRJED_nO3F5","title":"bopH4PoCWuIis_PHJJJa","description":"nMVF2rVdI4TB2sZfWFmu","button":"Uk1Z_T0AXY71Kl9jiI0f","pulse":"_1pC8h_eeWA0YfisHi3GB"};